import axios from "axios";
import { toast } from "react-toastify";
import { PowoPdfApi, ResendPoMailApi } from ".";

export const fetchPoPdfs = ({ po_id }) => {
  return axios
    .get(`${PowoPdfApi}${po_id}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const resendPoMail = (params = {}) => {
  const id = toast.loading("Sending PO mail");

  return axios
    .get(`${ResendPoMailApi}`, { params: { ...params } })
    .then((res) => {
      toast.update(id, {
        render: "Mail sent",
        type: "success",
        isLoading: false,
      });

      return res?.data;
    })
    .catch(() => {});
};
